<template>
    <h3 style="text-align: left;">Información General</h3>
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3" >
            <label  for="name" >Razón Social:<span class="is-invalid">*</span> </label>
           
        </div>
        <div class="col-md-7">
            <input type="text" class="form-control" id="razon_social" v-model="form.razon_social" required />
            <label class="is-invalid">{{validation.razon_social}}</label>
        </div>
    </div>
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Nombre del representante de la instalación:<span class="is-invalid">*</span> </label>
           
        </div>
        <div class="col-md-7" >
            <input type="text" class="form-control" id="razon_social" v-model="form.nombre_representante" required />
            <label class="is-invalid">{{validation.nombre_representante}}</label>
        </div>
    </div>
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Email:<span class="is-invalid">*</span> </label>
           
        </div>
        <div class="col-md-7">
            <input type="email" class="form-control" id="email" v-model="form.email" required />
            <label class="is-invalid">{{validation.email}}</label>
        </div>
    </div>
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Inspector: </label>
           
        </div>
        <div class="col-md-7">
            
            <select class="form-control" v-model="form.inspector" required>
                <option></option>
                <option :value="datos.name" v-for="datos  in datosinspectores">{{datos.name }}</option>
            </select>
            <label class="is-invalid"></label>
        </div>
    </div>    
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Número de Visitas: </label>
           
        </div>
        <div class="col-md-7">
            <input type="number" class="form-control" id="numero_visitas" v-model="form.numero_visitas" required />
            <label class="is-invalid"></label>
        </div>
    </div>  
       
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Tipo: </label>
           
        </div>
        <div class="col-md-7">
            
            <select class="form-control" id="tipo" v-model="form.tipo" required>
                <option value="Generación distribuida">Generación distribuida</option>
                <option value="Generación distribuida con obra">Generación distribuida con obra</option>
                <option value="Centrales electricas - MT">Centrales electricas - MT</option>
                <option value="Centrales electricas - MT">Centrales electricas</option>
                <option value="Centro de Carga - MT">Centro de Carga - MT</option>
                <option value="Centro de Carga">Centro de Carga</option>

            </select>
            <label class="is-invalid"></label>
        </div>
    </div>   
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Dirección:<span class="is-invalid">*</span> </label>
           
        </div>
        <div class="col-md-7">
            <input type="text" class="form-control" id="direccion" v-model="form.direccion" required />
            <label class="is-invalid">{{validation.direccion}}</label>
        </div>
    </div>
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Capacidad:<span class="is-invalid">*</span> </label>
           
        </div>
        <div class="col-md-7">
            <input type="text" class="form-control" id="capacidad" v-model="form.capacidad" required />
            <label class="is-invalid">{{validation.capacidad}}</label>
        </div>
    </div>  
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Unidad: </label>
           
        </div>
        <div class="col-md-7">
            
            <select class="form-control" id="unidad" v-model="form.unidad" required>
                <option value="kW">kW</option>
                <option value="MW">MW</option>
               

            </select>
            <label class="is-invalid"></label>
        </div>
    </div>   
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Importe: </label>
           
        </div>
        <div class="col-md-7">
            <input type="text" class="form-control" id="importe" v-model="form.importe" required />
            <label class="is-invalid"></label>
        </div>
    </div>   
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Voltaje de Conexión: </label>
           
        </div>
        <div class="col-md-7">
            
            <select class="form-control" id="importe" v-model="form.voltaje_conexion" required >
                <option value="Alta Tensión">Alta Tensión</option>
                <option value="Media Tensión">Media Tensión</option>
                <option value="Media Tensión">Baja Tensión</option>
               

            </select>
            <label class="is-invalid"></label>
        </div>
    </div>  
    </hr> 
    <h3 style="text-align: left;">Documentos</h3>
    <div class="py-1 row" style="text-align: left;">
        <div class="col-md-3">
            <label  for="name" >Oficio CFE: </label>
           
        </div>
        <div class="col-md-7">
            <input type="file" @change="onFileChange" accept="application/pdf" class="form-control"/>
            <div v-if="file">
            <h3>Vista previa del archivo:</h3>
            <iframe :src="fileURL" width="100%" height="400"></iframe>
            </div>
            
        </div>
    </div>
    <br>    
    <button type="button" class="btn btn btn-dark">
        <router-link to="/cotizacion">
            Cancelar
        </router-link>
    </button> &nbsp;
    <button type="button" class="btn btn btn-dark" @click="actualizar">
        Guardar
    </button>
    <br>
</template>

<script>
  import axios from 'axios';
  import "vue3-easy-data-table/dist/style.css";
  import Swal from 'sweetalert2';
  export default {
    data() {
      return {
        
        searchField:[],
        searchValue:[],
        datoscotizaciones:[],
        show: false,
        form: {
          razon_social: '',
          nombre_representante: '',
          email: '',
          inspector: '',
          numero_visitas: '',
          tipo: 'Generación distribuida',
          direccion: '',
          capacidad: '',
          unidad: 'kW',
          importe: '',
          voltaje_conexion: 'Alta Tensión',
          oficio_cfe: '',
        usuario :localStorage.getItem('name')
        },
        validation:{
            razon_social:"",
            nombre_representante:'',
            email:'',
            direccion:'',
            capacidad:''
        },
        headers:[],
        datosinspectores:[],
      };
    },
    created() {
        this.consultarCotizacion();
        this.consultarInspector();
    },
    methods: {
        consultarInspector(){
        const token = localStorage.getItem('accessToken');
            const config = {
                headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
                }
            };
       
            axios.get(this.$rutaServer+'inspectores',config).then(response => {
                this.datosinspectores = response.data.data;
            })
          .catch(error => {
            console.error('Error submitting form:', error);
           
          });
      },
        consultarCotizacion(){
            var idcotizacion = localStorage.getItem('idcotizacion');
            axios.post(this.$rutaServer+'datosCotizacion', { id: idcotizacion })
          .then(response => {
            if (response.status == 200) {
                this.datoscotizaciones = response.data.data[0];
                this.form.nombre_representante = response.data.data[0].nombre_representante;
                this.form.razon_social = response.data.data[0].razon_social;
                this.form.email = response.data.data[0].email;
                this.form.inspector = response.data.data[0].inspector;
                this.form.capacidad = response.data.data[0].capacidad;
                this.form.direccion = response.data.data[0].direccion;
                this.form.importe = response.data.data[0].importe;
                this.form.numero_visitas = response.data.data[0].numero_visitas;
                this.form.tipo = response.data.data[0].tipo;
                this.form.unidad = response.data.data[0].unidad;
                this.form.usuario = response.data.data[0].usuario;
            }
          })
          .catch(error => {
            Swal.fire('¡Error!', 'Ocurrió un error', 'error');
          });
        },
        actualizar(){
            var idcotizacion = localStorage.getItem('idcotizacion');
            const formData = new FormData();
            //formData.append('pdf', this.file);
            //formData.append('folio', this.form.folio);
            formData.append('fecha', this.form.fecha);
            formData.append('cie', this.form.cie);
            formData.append('razon_social', this.form.razon_social);
            formData.append('nombre_representante', this.form.nombre_representante);
            formData.append('email', this.form.email);
            formData.append('inspector', this.form.inspector);
            formData.append('numero_visitas', this.form.numero_visitas);
            formData.append('tipo', this.form.tipo);
            formData.append('direccion', this.form.direccion);
            formData.append('capacidad', this.form.capacidad);
            formData.append('unidad', this.form.unidad);
            formData.append('importe', this.form.importe);
            formData.append('voltaje_conexion', this.form.voltaje_conexion);
            formData.append('oficio_cfe', this.form.oficio_cfe);
            formData.append('usuario', localStorage.getItem('email'));
            formData.append('idcotizacion', idcotizacion);

            
            axios.post('https://api.seigrupo.com.mx/api/actualizarcotizacion',  formData ).then(response => {
            if (response.status == 200) {
                Swal.fire('Exito!', 'Se actualizo con exito la cotización', 'success');
                this.consultarCotizacion();
            }
          })
          .catch(error => {
            Swal.fire('¡Error!', 'Ocurrió un error', 'error');
          });
        }
    },
}
</script>
<style>
.is-invalid {
    color: red;
}
</style>